export const CHANGE_LEFT = 'change_left';
export const CHANGE_TOP = 'change_top';
